import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { HomeRoutingModule } from './home-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CoreModule } from '../../core/core.module';
import { CustomerFormModalComponent } from '../../customer-form-modal/customer-form-modal.component';
import { CustomerManagementPageComponent } from '../../customer-management-page/customer-management-page.component';
import { DeviceFormModalComponent } from '../../device-form-modal/device-form-modal.component';
import { DeviceManagementPageComponent } from '../../device-management-page/device-management-page.component';
import { HelpModalComponent } from '../../help-modal/help-modal.component';
import { CustomerManagementService } from '../../services/customer-management/customer-management.service';
import { HomeComponent } from '../home/home.component';
import { DeviceManagementService } from 'src/app/services/device-management/device-management.service';
import { LookupFormModalComponent } from 'src/app/lookup-form-modal/lookup-form-modal.component';
import { LookupFormComponent } from 'src/app/lookup-form/lookup-form.component';
import { BulkEditDeviceModalComponent } from 'src/app/bulk-edit-device-modal/bulk-edit-device-modal.component';
import { CustomerWrapperComponent } from 'src/app/customer-wrapper/customer-wrapper.component';
@NgModule({
  declarations: [
    CustomerManagementPageComponent,
    CustomerFormModalComponent,
    DeviceManagementPageComponent,
    DeviceFormModalComponent,
    LookupFormModalComponent,
    BulkEditDeviceModalComponent,
    HelpModalComponent,
    HomeComponent,
    LookupFormComponent,
    CustomerWrapperComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    HomeRoutingModule,
    MatTableModule,
    MatFormFieldModule,
    MatPaginatorModule,
    MatInputModule,
    MatSortModule,
    MatProgressSpinnerModule,
    MatCardModule,
    MatSlideToggleModule,
    MatToolbarModule,
    MatButtonModule,
    MatSidenavModule,
    MatIconModule,
    MatListModule,
    MatSelectModule,
    MatBadgeModule,
    MatCheckboxModule,
    MatTooltipModule,
    MatMenuModule,
    NgbModule,

    // App Modules
    CoreModule,
    FormsModule
  ],
  exports: [CustomerWrapperComponent],
  providers: [DeviceManagementService],
  bootstrap: [HomeComponent],
})
export class HomeModule {}
